import {LOCATION_CHANGE} from 'react-router-redux';

import {SIDEBAR_CLOSE, SIDEBAR_OPEN, SIDEBAR_TOGGLE} from '../actions/navigation';

export default(state = {
    context: {},
    sidebar: false
}, action) => {
    switch (action.type) {
        case LOCATION_CHANGE:
        case SIDEBAR_CLOSE:
            return {
                ...state,
                sidebar: false
            };
        case SIDEBAR_OPEN:
            return {
                ...state,
                sidebar: true
            };
        case SIDEBAR_TOGGLE:
            return {
                ...state,
                sidebar: !state.sidebar
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/navigation.js